<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="(record) => record.id"
        :columns="columns"
        :dataSource="houseData"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{ name }}</div>
          </div>
        </template>
        <template slot="code" slot-scope="code">
          <div>
            <div class="font-weight-bold">{{ code }}</div>
          </div>
        </template>
        <template slot="description" slot-scope="description">
          <div>
            <div class="font-weight-bold">{{ description }}</div>
          </div>
        </template>
        <!-- <template slot="class_sections_count" slot-scope="class_sections_count">
          <div>{{class_sections_count}}</div>
        </template> -->
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a
              href="javascript:;"
              v-if="rolesetting.editable"
              class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
              Edit
            </a>
            <a-tooltip placement="top">
              <template slot="title" v-if="record.enrollments_count !== 0">
                <span>Cannot Delete. Already assigned to Student !</span>
              </template>
              <span>
                <!-- Delete -->
                <a
                  href="javascript:;"
                  v-if="rolesetting.deletable"
                  class="btn btn-sm btn-danger btn-with-addon"
                  @click="onDelete(record)"
                  :class="record.enrollments_count !== 0 ? 'disabled' : ''"
                >
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </span>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <edit-school-house ref="editHouse" @edited="handleEdited" />
  </div>
</template>
<script>
import moment from 'moment'
import EditSchoolHouse from '@/components/schoolhouse/Forms/Edit/index'

const columns = [
  {
    title: 'House name',
    className: 'text-left',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Description',
    className: 'text-left text-gray-6',
    dataIndex: 'description',
    scopedSlots: { customRender: 'description' },
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Code',
    className: 'text-left text-gray-6',
    dataIndex: 'code',
    scopedSlots: { customRender: 'code' },
    sorter: (a, b) => a.name.length - b.name.length,
  },
  //   {
  //     title: 'No. of sections',
  //     dataIndex: 'class_sections_count',
  //     scopedSlots: { customRender: 'class_sections_count' },
  //     sorter: (a, b) => a.class_sections_count - b.class_sections_count,
  //   },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'SchoolHousesTable',
  components: {
    EditSchoolHouse,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    houseData: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function () {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  watch: {
    housesData: function () {
      console.log('housesData changed', this.housesData)
    },
  },
  computed: {
    computedSelect: function () {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function (record) {
      // this.$refs.editClass.showModal(record.id)
      this.$eventBus.$emit('openSchoolHouseEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    handleDate: function ($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onDelete: function (record) {
      this.$confirm({
        title: 'Are you sure delete this board?',
        content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/house/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch((error) => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
